export { default } from 'pages/account/comm-preferences-v2';
